import { iBisViewComponent } from '@dohu/ibis-common';
import { Component, Input, ViewChild } from '@angular/core';
import { ProxyService } from '../../../service/proxy.service';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import { EditServicePackageService } from './edit-service-package.service';

@Component({
	selector: 'app-service-package',
	templateUrl: './service-package.component.html'
})
export class ServicePackageComponent extends iBisViewComponent {
	@Input() packageId: any = null;
	@ViewChild('gridServicePackage') declare grid: DxDataGridComponent;
	public declare edit: EditServicePackageService;
	constructor(public proxy: ProxyService) {
		super(proxy.servicePackage, proxy.lg, proxy.iui, proxy.activatedRoute);
		this.key = '[MDS]Service';
	}

	onGridInit(ev: any) {
		//this.edit.packageId = this.packageId;
	}

	protected prepareNew(): any {
		const result = this.edit.createDefault();
		result.packageId = this.packageId;
		return result;
	}
}
